import { payload_ } from '@kepler.gl/reducers';
import { makeActionCreator } from '../../../config/store/utils';
import {
  readAnomaliesCycle,
  readTruckGpsPoints,
} from '../../../services/monitoringService';

// Action Types
export const GET_ANOMALIES_CYCLE = 'GET_ANOMALIES_CYCLE';
export const GET_ANOMALIES_CYCLE_ERROR = 'GET_ANOMALIES_CYCLE_ERROR';
export const GET_ANOMALIES_CYCLE_SUCCESS = 'GET_ANOMALIES_CYCLE_SUCCESS';

// Action Creators
export const onGetAnomaliesCycle = makeActionCreator(GET_ANOMALIES_CYCLE);
export const onGetAnomaliesCycleError = makeActionCreator(
  GET_ANOMALIES_CYCLE_ERROR,
  'payload'
);
export const onGetAnomaliesCycleSuccess = makeActionCreator(
  GET_ANOMALIES_CYCLE_SUCCESS,
  'payload'
);

// Async action to fetch the cycle anomalies data
export const onGetAnomaliesCycleThunk = ({
  year,
  month,
  day,
  shift,
}) => async dispatch => {
  dispatch(onGetAnomaliesCycle());
  try {
    const response = await readAnomaliesCycle({ year, month, day, shift });
    const data = JSON.parse(response.data);

    // Calculate duracion for each item
    const dataWithDuration = data.map((item, index) => {
      const inicio = new Date(item.inicio_ciclo);
      const fin = new Date(item.fin_ciclo);
      const duracionMinutes = (fin - inicio) / (1000 * 60); // Convert milliseconds to minutes

      return {
        ...item,
        id: `cycle-anomaly-${index}`,
        duracion: Math.round(duracionMinutes * 100) / 100, // Round to 2 decimal places
      };
    });
    dispatch(
      onGetAnomaliesCycleSuccess({
        data: dataWithDuration,
      })
    );
  } catch (error) {
    console.log(error);
    dispatch(
      onGetAnomaliesCycleError({
        error: error.message || 'Error fetching data',
      })
    );
  }
};

// Action Types
export const GET_TRUCK_GPS_POINTS = 'GET_TRUCK_GPS_POINTS';
export const GET_TRUCK_GPS_POINTS_ERROR = 'GET_TRUCK_GPS_POINTS_ERROR';
export const GET_TRUCK_GPS_POINTS_SUCCESS = 'GET_TRUCK_GPS_POINTS_SUCCESS';
export const CLEAR_TRUCK_GPS_POINTS = 'CLEAR_TRUCK_GPS_POINTS';

// Action Creators
export const onGetTruckGpsPoints = makeActionCreator(GET_TRUCK_GPS_POINTS);
export const onGetTruckGpsPointsError = makeActionCreator(
  GET_TRUCK_GPS_POINTS_ERROR,
  'payload'
);
export const onGetTruckGpsPointsSuccess = makeActionCreator(
  GET_TRUCK_GPS_POINTS_SUCCESS,
  'payload'
);
export const onClearTruckGpsPoints = makeActionCreator(CLEAR_TRUCK_GPS_POINTS);

// Async action to fetch GPS points for a specific truck
export const onGetTruckGpsPointsThunk = ({
  patente,
  fecha_inicio,
  fecha_termino,
}) => async dispatch => {
  dispatch(onGetTruckGpsPoints()); // Start loading
  try {
    const response = await readTruckGpsPoints({
      patente,
      fecha_inicio,
      fecha_termino,
    });

    const {
      data = [],
      count = 0,
      patente: truckPatente,
      fecha_inicio: startTime,
      fecha_termino: endTime,
    } = response.data;

    // Add IDs to each GPS point
    const gpsPointsData = data;

    // Dispatch success with GPS data
    dispatch(
      onGetTruckGpsPointsSuccess({
        data: gpsPointsData,
        count,
        patente: truckPatente,
        fecha_inicio: startTime,
        fecha_termino: endTime,
      })
    );
  } catch (error) {
    console.log(error);
    dispatch(
      onGetTruckGpsPointsError({
        error: error.message || 'Error fetching GPS points',
      })
    ); // Dispatch error
  }
};
